var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDualtoneStudents48 = function SvgAIconDualtoneStudents48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.1127C31 24.4687 27.4183 28 23 28C18.5817 28 15 24.4687 15 20.1127V14C15 12.8954 15.8954 12 17 12H29C30.1046 12 31 12.8954 31 14V20.1127Z",
    fill: "#FDEBED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17969 11.7272V14.9999C9.17969 19.5186 12.8428 23.1817 17.3615 23.1817C21.8802 23.1817 25.5433 19.5186 25.5433 14.9999V11.7272",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.271 6H2.63477V15.1888",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5433 6V11.7273H9.17969V6",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8203 29.7272L17.3664 36.2726M17.3664 36.2726L23.9112 29.7272M17.3664 36.2726V41.9999",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7272 42.0001C33.1105 33.7011 25.968 27.2728 17.3636 27.2728C8.75915 27.2728 1.61666 33.7011 1 42.0001",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconDualtoneStudents48 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0iTTMxIDIwLjExMjdDMzEgMjQuNDY4NyAyNy40MTgzIDI4IDIzIDI4QzE4LjU4MTcgMjggMTUgMjQuNDY4NyAxNSAyMC4xMTI3VjE0QzE1IDEyLjg5NTQgMTUuODk1NCAxMiAxNyAxMkgyOUMzMC4xMDQ2IDEyIDMxIDEyLjg5NTQgMzEgMTRWMjAuMTEyN1oiIGZpbGw9IiNGREVCRUQiLz4KICAgIDxwYXRoIGQ9Ik05LjE3OTY5IDExLjcyNzJWMTQuOTk5OUM5LjE3OTY5IDE5LjUxODYgMTIuODQyOCAyMy4xODE3IDE3LjM2MTUgMjMuMTgxN0MyMS44ODAyIDIzLjE4MTcgMjUuNTQzMyAxOS41MTg2IDI1LjU0MzMgMTQuOTk5OVYxMS43MjcyIiBzdHJva2U9IiNFMjAwMUEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMzEuMjcxIDZIMi42MzQ3N1YxNS4xODg4IiBzdHJva2U9IiNFMjAwMUEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMjUuNTQzMyA2VjExLjcyNzNIOS4xNzk2OVY2IiBzdHJva2U9IiNFMjAwMUEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMTAuODIwMyAyOS43MjcyTDE3LjM2NjQgMzYuMjcyNk0xNy4zNjY0IDM2LjI3MjZMMjMuOTExMiAyOS43MjcyTTE3LjM2NjQgMzYuMjcyNlY0MS45OTk5IiBzdHJva2U9IiNFMjAwMUEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMzMuNzI3MiA0Mi4wMDAxQzMzLjExMDUgMzMuNzAxMSAyNS45NjggMjcuMjcyOCAxNy4zNjM2IDI3LjI3MjhDOC43NTkxNSAyNy4yNzI4IDEuNjE2NjYgMzMuNzAxMSAxIDQyLjAwMDEiIHN0cm9rZT0iI0UyMDAxQSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";